export enum NotificationLevelEnum {
  INFO,
  WARNING,
  ERROR,
  SUCCESS
}

export interface NotificationInterface {
  id: number;
  code: string;
  param: string;
  url: string;
  level: NotificationLevelEnum;
  userId: number;
  clinicId: number;
  createdAt: Date;
}
